export default __webpack_public_path__ + "static/media/twitterLogo.61338219.svg";